import { IValidationRule } from "@/types"

const downtimePeriodValidationRules: { [s: string]: IValidationRule } = {
    description: {
        required: true,
    },
    start: {
        required: true,
    },
    end: {
        required: true,
    },
    discount: {
        required: true,
        type: "decimal",
        min: 0.01,
        max: 100,
    }
}

export default downtimePeriodValidationRules
